import { Component, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { ExpandpanelComponent } from './expandpanel/expandpanel.component';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'MapIndy-HELP';
  panelsTotal: Object = {};
  @ViewChildren(ExpandpanelComponent) exPanels: QueryList<ExpandpanelComponent> = new QueryList();
  panelsContent: Array<any> = [];
  defaultTheme: string = "mapindy";

  constructor(private http: HttpClient, private activateRoute: ActivatedRoute, private cdr: ChangeDetectorRef, private router: Router) {
  }

  //#region initialization
  ngAfterViewInit() {
    // available here
    this.panelsTotal = { number: this.exPanels["length"] };
    this.getHelpContent();
    this.activateRoute.queryParams.subscribe(params => {
      if (params.theme) {
        this.defaultTheme = params.theme;
      }      
    });

    this.exPanels.changes.subscribe(r => {
      const exPanelsArray: Array<ExpandpanelComponent> = this.exPanels.toArray().filter(p => p.parent == true);
      if (exPanelsArray.length > 0)
        for (let i: number = 0; i < exPanelsArray.length; i++) {
          if (exPanelsArray[i].panelTitle.toLowerCase() == this.defaultTheme.toLowerCase()) {
            exPanelsArray[i].isExpanded = true;
          } else {
            exPanelsArray[i].isExpanded = false;
          }
        }
        this.cdr.detectChanges();        
    });
  }

  onPanelExpanded(panel: ExpandpanelComponent) {
    if (panel.parent == true) {
      if (panel.isExpanded == true) {
        panel.isExpanded = false;
        return;
      } else {
        // this.router.navigateByUrl("?theme=" + panel.panelTitle.toLowerCase());
        const exPanelsArray: Array<ExpandpanelComponent> = this.exPanels.toArray().filter(p => p.parent == true);
        for (let i: number = 0; i < exPanelsArray.length; i++) {
          if (exPanelsArray[i].panelTitle == panel.panelTitle) {
            exPanelsArray[i].isExpanded = true;
          } else {
            exPanelsArray[i].isExpanded = false;
          }
        }
      }
    } else {
      if (panel.isExpanded == true) {
        panel.isExpanded = false;
        return;
      } else {
        const exPanelsArray: Array<ExpandpanelComponent> = this.exPanels.toArray().filter(p => (p.parent == false && p.parentPanel == panel.parentPanel));
        for (let i: number = 0; i < exPanelsArray.length; i++) {
          if (exPanelsArray[i].panelTitle == panel.panelTitle) {
            exPanelsArray[i].isExpanded = true;
          } else {
            exPanelsArray[i].isExpanded = false;
          }
        }
      }
    }
  }

  getHelpContent() {
    this.http.get("assets/content.json").toPromise().then(res => {
      console.log(res);
      this.panelsContent = res as Array<any>;
      if (this.defaultTheme != "") {
        this.panelsContent = this.panelsContent.filter(x => x.title.toLowerCase() == this.defaultTheme.toLowerCase());
        document.title = this.panelsContent[0]?.browserPageTitle;
      }
    });
  }
}
